import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2d81eb9e"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $options.computedIcon ? (_openBlock(), _createElementBlock("i", {
    key: 0,
    innerHTML: $options.computedIcon
  }, null, 8, _hoisted_1)) : _createCommentVNode("", true);
}